import { render, staticRenderFns } from "./MoyasarStcPayModal.vue?vue&type=template&id=1ed4a4f1&"
import script from "./MoyasarStcPayModal.vue?vue&type=script&lang=js&"
export * from "./MoyasarStcPayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports